import { FC, useState, MouseEvent } from 'react'

import { utils } from '../../../utils'
import { Card, Icon, Loading, Paginate, Table, TableLabel, TableText, Text } from '../../UI'
import { Modal, useModal } from '../../UI/Modal'
import { FamilyGroupFilter, RequestedBudgetDocuments } from '..'
import { useDataPage } from '../../../hooks'

type RequestedBudgetFormProps = {
  className?: string,
  data: any[] | null,
  familyFilter: any,
  familyFilterSelected: string,
  onFamilyFilterChange?(patientId: string): void
}

const pageSizeDefault: number = 5
const tableAttrsShowDefault = utils.getArrayBooleanDefault(pageSizeDefault)

const BudgetsRequested:FC<RequestedBudgetFormProps> = ({ className = '', data, familyFilter, familyFilterSelected, onFamilyFilterChange }) => {
  const dataPage = useDataPage(data, pageSizeDefault)
  const [tableAttrsShow, setTableAttrsShow] = useState<boolean[]>(tableAttrsShowDefault)
  const [budgetSelected, setBudgetSelected] = useState<any>({})
  const modal = useModal()

  const tableColumns = [
    {
      accessor: 'tipo_intervencion.nombre',
      Header: 'Tipo de intervención',
      width: '35%'
    },
    {
      accessor: 'medico_tratante',
      Header: 'Médico tratante',
      width: '35%'
    },
    {
      accessor: 'fecha_recepcion',
      Header: 'Fecha de solicitud',
      width: '15%',
      Cell: (params: any) => {
        const { value } = params
        return utils.getDateFormat(value, 'DD/MM/YYYY')
      }
    },
    {
      accessor: 'view',
      Header: 'Ver',
      width: '15%',
      Cell: (params: any) => {
        const { original } = params.row

        return (
          <div className="text-center">
            <a href="# " onClick={(event) => onTableViewMore(event, original)}>
              <Icon name="view" />
            </a>
          </div>
        )
      }
    }
  ]

  const onFilterChange = (id: string) => {
    dataPage.setPageCurrent()
    if(onFamilyFilterChange) onFamilyFilterChange(id)
  }

  const onTableBtnShowMore = (index: number) => {
    setTableAttrsShow(prevState => prevState.map((item, idx) => idx === index ? !item : item))
  }

  const onTableViewMore = (event: MouseEvent<HTMLAnchorElement> | MouseEvent<HTMLButtonElement>, item: any) => {
    event.preventDefault()
    setBudgetSelected(item)
    modal.open()
  }

  return (
    <>
      <div className={`request-budget-wrapper ${className}`}>
        <FamilyGroupFilter
          data={familyFilter.data}
          dataSelected={familyFilterSelected}
          onChange={onFilterChange}
        />

        {dataPage.data ?
            dataPage.data.length ?
                <>
                  <div className="mt-20">
                    <div className="d-none lg:d-block">
                      <Table
                        columns={tableColumns}
                        data={dataPage.data}
                      />
                    </div>

                    <div className="d-block lg:d-none">
                      {dataPage.data.map((it: any, i: number) =>
                        <Card key={i} className={`py-20 px-25 ${i > 0 ? 'mt-20' : ''}`}>
                          <div>
                            <TableLabel>Tipo de intervención</TableLabel>
                            <TableText>{it.tipo_intervencion?.nombre}</TableText>
                          </div>

                          {tableAttrsShow[i] &&
                            <>
                              <div className="mt-10">
                                <TableLabel>Médico tratante</TableLabel>
                                <TableText>{it.medico_tratante}</TableText>
                              </div>

                              <div className="mt-10">
                                <TableLabel>Fecha de solicitud</TableLabel>
                                <TableText>{utils.getDateFormat(it.fecha_recepcion, 'DD/MM/YYYY')}</TableText>
                              </div>

                              <div className="mt-10">
                                <TableLabel inline>Ver</TableLabel>

                                <a href="# " className="ml-15" onClick={(event) => onTableViewMore(event, it)}>
                                  <Icon name="view" />
                                </a>
                              </div>
                            </>
                          }

                          {!tableAttrsShow[i] &&
                            <div className="text-center mt-20" onClick={() => onTableBtnShowMore(i)}>
                              <div className="d-inline px-10">
                                <Icon name="arrow-down" />
                              </div>
                            </div>
                          }
                        </Card>
                      )}
                    </div>
                  </div>

                  <div className="text-center mt-20">
                    <Paginate
                      current={dataPage.pageCurrent}
                      total={data ? data.length : 0}
                      size={pageSizeDefault}
                      onPageChange={(current) => dataPage.onPageCurrent(current)}
                    />
                  </div>
                </>
              :
                <div className="request-budget-empty">
                  <Text size="20" weight="bold">No tienes presupuestos solicitados en este historial</Text>
                </div>
          :
            <Loading size="md" align="center" className="pt-70 lg:pt-100" />
        }
      </div>

      <Modal show={modal.show} maxWidth="415px" onClose={() => modal.close()}>
        <RequestedBudgetDocuments data={budgetSelected} />
      </Modal>
    </>
  )
}

export { BudgetsRequested }